<myarvato-page-with-drawer data-clarity-mask="true">
  <transport-detail-sidebar sidebar [details]="details()" />
  <div main class="d-flex flex-column gap--24">
    <transport-parcel-details [details]="details()" />
    <transport-details-milestones [details]="details()" />
    @if (details().bulk) {
      <transport-details-bulk [details]="details()" />
    }
    <transport-details-event-history [details]="details()" />
    <transport-details-sender-recipient [details]="details()" />
    <transport-details-contents [details]="details()" />
    <transport-details-documents [details]="details()" />
  </div>
</myarvato-page-with-drawer>
